<template>
   <button
      :aria-label="ariaLabel"
      type="button"
      class="btn btn-light"
      v-popover
      ref="tooltip"
      data-container="body"
      @click="removeFilter"
   >
      <!--
      data-toggle="popover"
      data-trigger="hover"
      data-placement="bottom"
      data-content="Click to remove this filter"

   -->
      {{ label }}

      <svg
         width="1em"
         height="1em"
         viewBox="0 0 16 16"
         class="bi bi-x pull-right"
         fill="currentColor"
         xmlns="http://www.w3.org/2000/svg"
      >
         <path
            fill-rule="evenodd"
            d="M11.854 4.146a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708-.708l7-7a.5.5 0 0 1 .708 0z"
         />
         <path
            fill-rule="evenodd"
            d="M4.146 4.146a.5.5 0 0 0 0 .708l7 7a.5.5 0 0 0 .708-.708l-7-7a.5.5 0 0 0-.708 0z"
         />
      </svg>

      <div v-if="className" :class="className" aria-hidden="true"></div>
   </button>
</template>

<script>
import $ from 'jquery';
/* eslint-disable vue/require-prop-types */
export default {
   name: 'FilterButton',
   props: ['label', 'className'],
   computed: {
      ariaLabel: function () {
         return `${this.label} - Click to remove filter`;
      },
   },
   methods: {
      removeFilter: function (evt) {
         // console.log('removeFilter', evt);
         $(evt.target).popover('hide');
         this.$emit('remove-filter');
      },
   },
};
</script>



// WEBPACK FOOTER //
// src/components/FilterButton.vue